"use client";

import { c as _c } from "react/compiler-runtime";
import { previewAtom } from "./dropdown";
import { useAtomValue } from "jotai";
import { Messaging } from "./svg/messaging";
import { ConsentWelcome } from "./svg/consent-welcome";
import { ColorGrid } from "./svg/color-grid";
export const PreviewScreens = () => {
  const $ = _c(3);
  const screen = useAtomValue(previewAtom);
  if (screen === "color-grid") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ColorGrid />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (screen === "messaging") {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Messaging />;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (screen === "consent") {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ConsentWelcome />;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
};